window.addEventListener('DOMContentLoaded', () => {
    const tabsItem = document.querySelectorAll(".iFaq_subItem");

    tabsItem.forEach(tab => tab.addEventListener("click", handleTabClick));

    function handleTabClick() {
        const open = this.dataset.open;
        const content = this.querySelector(".iFaq_subItem-content");

        if (open === "false") {
            this.classList.add("_showTab");
            content.style.maxHeight = content.offsetTop + "px";
            this.setAttribute("data-open", "true");
        } else {
            this.classList.remove("_showTab");
            content.style.maxHeight = 0 + "px";
            this.setAttribute("data-open", "false");
        }

        closeOtherTabs(this);
    }

    function closeOtherTabs(activeTab) {
        tabsItem.forEach(tab => {
            if (tab !== activeTab) {
                const open = tab.dataset.open;
                const content = tab.querySelector(".iFaq_subItem-content");

                if (open === "true") {
                    tab.classList.remove("_showTab");
                    content.style.maxHeight = 0 + "px";
                    tab.setAttribute("data-open", "false");
                }
            }
        });
    }
});